import { Form } from '@mairistem/composants';
import dayjs from 'dayjs';

import { formatMonetaire } from '@/utils';

interface TicketsProps {
  type: string;
  dateValidite: string;
  nombre: number;
  montantUnitaire: number;
}

const Tickets = (props: TicketsProps) => {
  const {
    type: typeProps,
    dateValidite: dateProps,
    nombre: nombreProps,
    montantUnitaire: montantUnitaireProps,
  } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>Tickets</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Type
        {' : '}
        <label>{typeProps}</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Date de validité
        {' : '}
        <label>{dayjs(dateProps).format('DD/MM/YYYY')}</label>
      </Form.Field>
      <Form.Field inline width={2}>
        Nombre
        {' : '}
        <label>{nombreProps}</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Montant unitaire
        {' : '}
        <label>{formatMonetaire(montantUnitaireProps, 2)}</label>
      </Form.Field>
      <Form.Field
        inline
        width={3}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(nombreProps * montantUnitaireProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default Tickets;
